import { useContext } from 'react'
import { VideoContext } from './VideoContext'

export const useVideoContext = () => useContext(VideoContext)
